<template>
  <el-dialog
    :title="formTitle"
    :visible.sync="isVisible"
    custom-class="dialog-short-form"
    :class="{'is-edit-mode': isEditMode, 'is-new': state === 'new'}"
    :closeOnClickModal="false"
    append-to-body
    @close="handleDialogClose">
    <div v-loading="isLoading">
      <form-editor
        :data="data"
        :model="formModel"
        @change="handleFormData"
        ref="Form"/>
      <form-controls
        class="form-footer"
        isCancel
        :isCreate="!hasCreateNew"
        :isSave="hasCreateNew"
        :isDelete="hasCreateNew"
        @command="setCommand"/>
    </div>
  </el-dialog>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'

export default {
  name: 'ModalNew',
  mixins: [FormWrapper],
  components: {
    'form-editor': () => import(/* webpackChunkName: 'RFQRepairTd' */ './Form'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  props: {
    config: { type: Object },
    partID: { required: true },
    rfqid: { required: true }

  },
  computed: {
    formTitle () {
      return this.formData.title || this.checkEs6AndRun(this.title)
    }
  },
  methods: {
    formModel () {
      return {
        id: '',
        qty: '',
        partNumber: '',
        partDescription: '',
        price: '',
        rfqid: this.rfqid,
        partID: this.partID
      }
    },
    handlePrepareData (data) {
      return {
        ...data,
        rfqid: this.rfqid,
        partID: this.partID
      }
    },
    handleDialogClose () {
      let command = this.isAvailableToSave ? 'back' : 'cancel'
      this.setCommand(command)
    }
  }
}
</script>
